<template>
  <div>
    <Breadcrumbs :classes="{ menu: true }"/>
    <div class="button-group mb-5 px-4">
      <button class="font-hiraginoSans-w6" :class="{ active: currentTab === 'all' }" @click="setTab('all')">すべて</button>
      <button class="font-hiraginoSans-w6" :class="{ active: currentTab === 'first' }" @click="setTab('first')">初回のみ</button>
      <button class="font-hiraginoSans-w6" :class="{ active: currentTab === 'second' }" @click="setTab('second')">2回目以降</button>
    </div>
    <div class="timeprice-container">
      <div v-for="timepricePair in filteredTimePrices" :key="timepricePair[0].id" class="timeprice-pair">
        <div class="container-fluid">
          <div class="row">
            <div v-for="timeprice in timepricePair" :key="timeprice.id" class="timeprice-card col-md-6 col-xs-12">
              <div class="card card-timeprice">
                <div class="card-body h-100 margin-card-flex">
                  <div class="row d-flex py-1 font-family-W3">
                    <div class="timeprice-booking col-md-8 w-20 break-words">
                      <p class="text-permalink-home font-hiraginoSans-w6 text-title bold-text">{{ timeprice.name }}</p>
                    </div>
                    <div class="col-12">
                      <div class="mr-3 text-permalink-home bold-text">
                        <span v-if="timeprice.timeunit">{{ timeprice.timeunit }}分</span>
                        <br v-else/>
                      </div>
                      <div class="mr-3 text-permalink-home bold-text">
                          <span v-if="timeprice.unitprice">{{
                              numberWithDelimiter(timeprice.unitprice)
                            }}円 (税込)</span>
                        <br v-else/>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between flex-grow-1">
                    <div class="img w-40">
                      <img :src="timeprice.timeprice_image.url" alt=""/>
                    </div>
                    <div v-if="(timeprice.timeprice_image && timeprice.timeprice_image.url) || timeprice.menu_explain"
                         class="show-modal-timeprice margin-top-auto margin-bottom-auto">
                      <a class="font-family-W3 cursor-timeprice" @click="showModal(timeprice)">
                        メニューの詳細を見る
                      </a>
                    </div>
                  </div>
                  <div class="d-flex text-right mt-auto">
                    <button class="btn-choose-timeprice text-center scroll-top mt-4" @click="chooseTimeprice(timeprice)">
                      <span>選択</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="timepricePair.length === 1" class="timeprice-card col-md-6 col-xs-12">
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper py-5">
      <div class="container">
        <div class="footer-buttons">
          <span class="back-step" @click="goBack">&lt; 戻る</span>
        </div>
      </div>
    </div>
    <Modal :show="showModalFlag" :option="selectedOption" @close="closeModal"/>
  </div>
</template>

<script>
import Breadcrumbs from './Breadcrumbs.vue';
import Modal from './Modal.vue';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'ChooseTimePrice',
  components: {
    Breadcrumbs,
    Modal
  },
  props: {
    timeprices: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentTab: 'all',
      showModalFlag: false,
      selectedOption: {}
    };
  },
  computed: {
    ...mapGetters('permalink', [
      'timeprices_clinic',
      'timepriceOptions'
    ]),
    filteredTimePrices() {
      let source = this.timeprices.length > 0 ? this.timeprices : this.timeprices_clinic;
      let filtered = [];
      if (this.currentTab === 'all') {
        filtered = source;
      } else if (this.currentTab === 'first') {
        filtered = source.filter(tp => tp.flag_first);
      } else if (this.currentTab === 'second') {
        filtered = source.filter(tp => tp.flag_second);
      }
      const pairs = [];
      for (let i = 0; i < filtered.length; i += 2) {
        pairs.push(filtered.slice(i, i + 2));
      }
      return pairs;
    }
  },
  methods: {
    ...mapActions('permalink', ['fetchTimepriceData', 'setTimepriceOptions', 'setSelectedTimeprice']),
    setTab(tab) {
      this.currentTab = tab;
    },
    async chooseTimeprice(timeprice) {
      await this.fetchTimepriceData(timeprice.id);
      this.setTimepriceOptions(this.timepriceOptions);
      this.setSelectedTimeprice(timeprice);
      this.$emit('showChooseTimePriceOption', timeprice.id);
    },
    goBack() {
      this.$emit('goBack');
    },
    showModal(timeprice) {
      this.selectedOption = timeprice;
      this.showModalFlag = true;
    },
    closeModal() {
      this.showModalFlag = false;
    },
    numberWithDelimiter(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
</script>

<style scoped>
.button-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.button-group button {
  font-size: 16px;
  flex: 1;
  margin: 0 5px;
  background-color: white;
  border-radius: 10px;
  border: 1px solid rgba(0,0,0,0.12);
  height: 48px;
  font-weight: bold;
  color: #00122E;
}

.button-group button:first-child {
  margin-left: 0;
}

.button-group button:last-child {
  margin-right: 0;
}

.button-group button.active {
  background-color: #026f56;
  color: white;
}

.timeprice-booking {
  flex: 1;
}

.img {
  max-width: 100%;
}

.w-40 {
  width: 40%;
}

.img img {
  max-width: 100%;
  height: auto;
  max-height: 150px;
}

.show-modal-timeprice {
  align-self: center;
}

.btn-choose-timeprice {
  align-self: flex-end;
}

.break-words {
  word-break: break-word;
}

.cursor-timeprice {
  cursor: pointer;
}

.row {
  margin-left: -15px !important;
  margin-right: -15px !important;
}

.flex-grow-1 {
  flex-grow: 1;
}
</style>
